import { Application, User } from '../types'

/* Check if a user have access to an application, returns true if the
 * user have acess to the application.
 *
 * @param application - The application name
 * @param user - The user to have the credentials checked
 */
export const hasAccessToTheApplication = (application: Application | string, user: User) => {
  if (!user.roles.length) return false

  return user.roles
    .flatMap((roleForClinics) => roleForClinics.role.applicationPermissions)
    .some((applicationPermission) => applicationPermission.application === application)
}

/* Check if a user have access to a view, returns true if the
 * user have access to the view.
 *
 * @param application - The application name
 * @param view - The view name
 * @param user - The user to have the credentials checked
 */
export const hasAccessToTheView = (application: Application | string, view: string, user: User) => {
  return (
    user.roles
      .flatMap((roleForClinics) => roleForClinics.role.applicationPermissions)
      .some((grantedPermission) => grantedPermission.view === view && grantedPermission.application === application) ||
    false
  )
}
